import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsFieldsAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-fields-associate',
	path: '/secure/admin/SelectFieldLayoutScheme!default.jspa',
};
